/**
 * 方位誤差の手動キャリブレーションUI(計画書F-5, §7.2)。
 * 実物の目標物と仮想マーカーが合うようにスライダーで回転オフセットを調整してもらう。
 * オフセットはlocalStorageに史跡ごとに永続化する。
 */
export class CalibrationUI {
  private root: HTMLElement;
  private toggleBtn: HTMLButtonElement;
  private storageKey: string;

  constructor(
    container: HTMLElement,
    toolbar: HTMLElement,
    siteId: string,
    onChange: (offsetDeg: number) => void,
  ) {
    this.storageKey = `shiseki-ar:calibration:${siteId}`;
    const saved = Number(localStorage.getItem(this.storageKey) ?? '0') || 0;

    this.root = document.createElement('div');
    this.root.className = 'calibration';
    this.root.style.display = 'none';
    this.root.innerHTML = `
      <div class="hint">
        遠くの目印(建物・山・鉄塔など)と画面内の3Dの向きが合うように調整してください。
      </div>
      <div class="row">
        <input type="range" min="-90" max="90" step="0.5" value="${saved}" />
        <div class="value">${fmt(saved)}</div>
      </div>
      <div class="actions">
        <button class="btn-small" data-act="reset">リセット</button>
        <button class="btn-small accent" data-act="close">完了</button>
      </div>
    `;

    const slider = this.root.querySelector('input') as HTMLInputElement;
    const valueEl = this.root.querySelector('.value') as HTMLElement;

    slider.addEventListener('input', () => {
      const v = Number(slider.value);
      valueEl.textContent = fmt(v);
      localStorage.setItem(this.storageKey, String(v));
      onChange(v);
    });
    (this.root.querySelector('[data-act="reset"]') as HTMLElement).addEventListener('click', () => {
      slider.value = '0';
      slider.dispatchEvent(new Event('input'));
    });
    (this.root.querySelector('[data-act="close"]') as HTMLElement).addEventListener('click', () => {
      this.root.style.display = 'none';
    });

    this.toggleBtn = document.createElement('button');
    this.toggleBtn.className = 'btn-small';
    this.toggleBtn.textContent = '🧭 方位調整';
    this.toggleBtn.addEventListener('click', () => {
      this.root.style.display = this.root.style.display === 'none' ? 'flex' : 'none';
    });

    toolbar.appendChild(this.toggleBtn);
    container.appendChild(this.root);

    // 保存値を起動時に適用
    if (saved !== 0) onChange(saved);
  }

  get savedOffsetDeg(): number {
    return Number(localStorage.getItem(this.storageKey) ?? '0') || 0;
  }
}

function fmt(v: number): string {
  return `${v > 0 ? '+' : ''}${v.toFixed(1)}°`;
}
